module.exports = __webpack_public_path__ + "static/media/Sylveon_gaussian2.6cc442cd.png";